export default "__VITE_ASSET__7ae62d73__"